







































import { Vue, Component } from 'vue-property-decorator';
import { UnitApi, Unit } from '@compassdigital/foodworks.api.ts';
import PageTitle from '@/components/PageTitle/index.vue';
import TabbedNavigation from '@/components/TabbedNavigation/index.vue';
import UnitContactDetail from '@/components/Form/Unit/UnitContactDetail/index.vue';
import NonWorkingDays from '@/components/Form/NonWorkingDays/index.vue';
import StandardCard from '@/components/Card/StandardCard/index.vue';
import UnitsUtil from '@/util/UnitUtil';
import ServiceUtil from '@/util/ServiceUtil';

@Component({
  components: {
    PageTitle,
    TabbedNavigation,
    StandardCard,
    UnitContactDetail,
    NonWorkingDays,
  },
})
export default class NonWorkingday extends Vue {
  public unitDetails: any = '';

  public marketItems: any = '';

  public mounted() {
    this.getMarkets();
    this.getUnitDetails();
  }

  public async getMarkets() {
    // this.marketItems = await ServiceUtil.getMarkets();
  }

  public async getUnitDetails() {
    const { id } = this.$route.params;
    const unit:any = await UnitApi.getUnit(id);
    // this.unitDetails = UnitsUtil.mappedDetailsUnit(unit, this.marketItems);
  }
}
